// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllAircrafts = createAsyncThunk('dashboard/getAllAircrafts', async () => {
  const response = await axios.get('/dashboard/aircrafts')
  return response.data
})

export const getAllProductivity = createAsyncThunk('dashboard/getAllProductivity', async () => {
  const response = await axios.get('/dashboard/productivity')
  return response.data
})

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    aircrafts: [],
    productivity: [],
    selected: null,
    isLoading: false,
    showTarget: false
  },
  extraReducers: {
    [getAllAircrafts.pending]: (state) => {
      state.isLoading = true
    },
    [getAllAircrafts.fulfilled]: (state, action) => {
      state.isLoading = false
      state.aircrafts = action.payload
    },
    [getAllProductivity.pending]: (state) => {
      state.isLoading = true
    },
    [getAllProductivity.fulfilled]: (state, action) => {
      state.isLoading = false
      state.productivity = action.payload
    }
  }
})
export default dashboardSlice.reducer
